import { Badge } from "@fluentui/react-components";
import * as React from "react";
import StringsStore from "sh-strings/store";

interface PreviewBadgeProps {
  size?: "small" | "medium" | "large" | "extra-large";
}

export const PreviewBadge = ({ size = "medium" }: PreviewBadgeProps) => {
    const styles = require("./PreviewBadge.scss");
    const _strings = StringsStore().registeredStringModules.get("header").strings;
    return (
        <Badge
        id="previewBadgeLabel"
        className= {styles.badge}
        appearance="tint"
        color="brand"
        size={size}
        shape="circular"
        aria-label = {_strings.get("previewBadgeText")}>
          {_strings.get("previewBadgeText")}
        </Badge>
    );
  };